export default __webpack_public_path__ + "static/media/logo.3ddd4636.svg";